import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicAuthGuard } from './guards/basic-auth.guard';
import { LandingPageComponent } from './components/landing-page/component';

const routes: Routes = [
  { path: '', component: LandingPageComponent , canActivate: [BasicAuthGuard], },
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
